import { deviceSelectId } from "../commands/deviceChangeCommand";

const cmdImport = 'gjs-open-import-webpage';

const cmdClear = 'canvas-clear';
const openCodeStr = 'open-code';
const getObject = 'code-editor-object';
const getConstuctor = 'code-editor-constructor';

export default (editor, opts) => {
    const { Panels } = editor;
    const config = editor.getConfig();
    const swv = 'sw-visibility';
    const expt = 'export-template';
    const osm = 'open-sm';
    const otm = 'open-tm';
    const ola = 'open-layers';
    const obl = 'open-blocks';
    const ful = 'fullscreen';
    const prv = 'preview';
    const iconStyle = 'style="display: block; max-width:22px"';


    Panels.getPanels().reset([
        {
            id: 'commands',
            buttons: [{}],
        },
        {
            id: 'devices-c',
            buttons: [
                {
                    id: 'devices-dropdown',
                    active: true,
                    label: `<select id="${deviceSelectId}" style="height: 26px; border-radius: 4px; background: transparent; color: #9da3af; border: 1px solid #9da3af; padding: 0 8px;">
                        <option value="desktop" selected>Desktop</option>
                        <option value="tabletHorizontal">Tablet Horizontal</option>
                        <option value="tablet">Tablet</option>
                        <option value="mobile">Mobile</option>
                    </select>`,
                },
            ],
        },
        {
            id: 'options',
            buttons: [
                {
                    id: swv,
                    command: swv,
                    context: swv,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
        <path fill="currentColor" d="M15,5H17V3H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M7,21H9V19H7M7,5H9V3H7V5Z" />
    </svg>`,
                },
                {
                    id: prv,
                    context: prv,
                    command: () => editor.runCommand(prv),
                    label: `<svg ${iconStyle} viewBox="0 0 24 24"><path fill="currentColor" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"></path></svg>`,
                },
                {
                    id: ful,
                    command: ful,
                    context: ful,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z" />
        </svg>`,
                },
                {
                    id: expt,
                    command: () => editor.runCommand(expt),
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z" />
        </svg>`,
                },
                {
                    id: 'undo',
                    command: () => editor.runCommand('core:undo'),
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z" />
        </svg>`,
                },
                {
                    id: 'redo',
                    command: () => editor.runCommand('core:redo'),
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z" />
        </svg>`,
                },
                {
                    id: cmdImport,
                    command: () => editor.runCommand(cmdImport),
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
        </svg>`,
                },
                {
                    id: 'cross-tab-copy',
                    command: 'cross-tab-copy',
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z" />
        </svg>`,
                    attributes: {
                        title: 'Copy Component (Cross-tab)',
                    },
                },
                {
                    id: 'cross-tab-paste',
                    command: 'cross-tab-paste',
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M19,20H5V4H7V7H17V4H19M12,2A1,1 0 0,1 13,3A1,1 0 0,1 12,4A1,1 0 0,1 11,3A1,1 0 0,1 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5A2,2 0 0,0 3,4V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V4A2,2 0 0,0 19,2Z" />
        </svg>`,
                    attributes: {
                        title: 'Paste Component (Cross-tab)',
                    },
                    active: false,
                },
                //         {
                //             id: cmdClear,
                //             command: () => editor.runCommand(cmdClear),
                //             label: `<svg ${iconStyle} viewBox="0 0 24 24">
                //       <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                //   </svg>`,
                //         },
            ],
        },
        {
            id: 'views',
            buttons: [
                {
                    id: osm,
                    command: osm,
                    active: true,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
            <path fill="currentColor" d="M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z" />
        </svg>`,
                },
                {
                    id: otm,
                    command: otm,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
          <path fill="currentColor" d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" />
      </svg>`,
                },
                {
                    id: ola,
                    command: ola,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
          <path fill="currentColor" d="M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z" />
      </svg>`,
                },
                {
                    id: obl,
                    command: obl,
                    label: `<svg ${iconStyle} viewBox="0 0 24 24">
          <path fill="currentColor" d="M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" />
      </svg>`,
                },
                {
                    id: openCodeStr,
                    command: openCodeStr,
                    label: `<svg title="code editor" ${iconStyle} class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8 8-4 4 4 4m8 0 4-4-4-4m-2-3-4 14"/>
                            </svg>
                            `,
                },
            ],
        },
    ]);

    const openBl = Panels.getButton('views', obl);
    editor.on('load', () => openBl?.set('active', true));

    // On component change show the Style Manager
    // opts.showStylesOnChange &&
    //     editor.on('component:selected', () => {
    //         const openSmBtn = Panels.getButton('views', osm);
    //         const openLayersBtn = Panels.getButton('views', ola);

    //         // Don't switch when the Layer Manager is on or
    //         // there is no selected component
    //         if (
    //             (!openLayersBtn || !openLayersBtn.get('active')) &&
    //             editor.getSelected()
    //         ) {
    //             openSmBtn?.set('active', true);
    //         }
    //     });
};
